export class ProductsListing {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.settings = JSON.parse(this.root.getAttribute('data-settings'));

        this.loadMoreButtonWrapper = this.root.querySelector(
            '.listing__button-wrapper'
        );
        this.loadMoreButton = this.loadMoreButtonWrapper.querySelector(
            '.js-load-more-button'
        );
        this.loader = this.root.querySelector('.loader');
        this.form = this.root.querySelector('form');
        if (this.form) {
            this.filterRootDivs = this.form.querySelectorAll('.form-select');
            this.closeFiltersButton = this.form.querySelector(
                '.listing__filters-close'
            );
            this.filterButton = this.form.querySelector('.js-filter-button');
            this.pageInput = this.form.querySelector("[name='page']");
        }
        this.htmlWrapper = this.root.querySelector('.listing__content');

        this.filtersShowButton = this.root.querySelector(
            '.listing__filters-button'
        );

        this.maxPages = this.settings.max_pages;
        this.currentPage = 1;

        this.isInitFetch = this.settings.is_init_fetch;
        this.blockSelectChange = this.isInitFetch ? true : false;
        this.filtersKeys = ['ce_points', 'modality', 'trainer'];

        this.isDesktop = window.innerWidth > 991.98;

        return true;
    }

    init() {
        if (this.filterRootDivs && this.filterRootDivs.length > 0)
            this.handleSelectEvent();
        if (this.filterButton) this.handleFilterButtonClick();
        if (this.loadMoreButton) this.handleLoadMoreEvent();
        if (this.filtersShowButton) this.handleFiltersShowButtonClick();
        if (this.closeFiltersButton) this.handleFiltersCloseButtonClick();

        if (
            this.isInitFetch &&
            this.form &&
            this.form.classList.contains('-filter')
        )
            this.handleInitFetch();

        window.addEventListener('resize', () => {
            this.isDesktop = window.innerWidth > 991.98;
        });
    }

    handleSelectEvent() {
        this.filterRootDivs.forEach(selectDiv => {
            selectDiv.addEventListener('onSelectChange', e => {
                if (this.isDesktop && !this.blockSelectChange) {
                    if (this.pageInput) this.pageInput.value = 1;
                    this.currentPage = 1;
                    setTimeout(async () => {
                        await this.fetchProducts();
                        this.handleURL();
                    }, 100);
                }
            });
        });
    }

    handleFilterButtonClick() {
        this.filterButton.addEventListener('click', () => {
            if (this.pageInput) this.pageInput.value = 1;
            this.currentPage = 1;
            setTimeout(async () => {
                await this.fetchProducts();
                this.handleURL();
                this.hideFilters();
            }, 100);
        });
    }

    handleLoadMoreEvent() {
        this.loadMoreButton.addEventListener('click', e => {
            this.setPage(parseInt(this.currentPage) + 1);
            this.fetchProducts(false);
        });
        this.loadMoreButton.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.setPage(parseInt(this.currentPage) + 1);
                this.fetchProducts(false);
            }
        });
    }

    setPage(pageToSet) {
        this.currentPage = pageToSet;
        this.pageInput.value = pageToSet;
    }

    handleFiltersShowButtonClick() {
        this.filtersShowButton.addEventListener(
            'click',
            this.showFilters.bind(this)
        );
    }

    handleFiltersCloseButtonClick() {
        this.closeFiltersButton.addEventListener(
            'click',
            this.hideFilters.bind(this)
        );
    }

    async handleInitFetch() {
        await this.fetchProducts(true);
        this.blockSelectChange = false;
    }

    async fetchProducts(replaceHtml = true) {
        this.loader.classList.add('-active');
        try {
            const formData = new FormData(this.form);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const { html, max_pages, page } = await req.json();
            const previousMaxPages = this.maxPages;
            this.maxPages = max_pages;
            this.currentPage = page;
            if (this.pageInput) this.pageInput.value = page;

            if (html) {
                if (replaceHtml) {
                    this.htmlWrapper.innerHTML = html;
                } else {
                    this.htmlWrapper.innerHTML += html;
                }
            }
        } catch (error) {
            console.log(`Error: ${error}`);
        } finally {
            this.loader.classList.remove('-active');
            this.handleButtonVisibility();
            if (window.innerWidth < 991.98) {
                window.scrollTo({
                    top:
                        this.htmlWrapper.getBoundingClientRect().top +
                        window.scrollY -
                        150,
                });
            }
        }
    }

    handleURL() {
        const currentUrl = new URL(window.location.href);
        currentUrl.search = '';

        const formData = new FormData(this.form);

        formData.forEach((value, key) => {
            if (this.filtersKeys.includes(key) && value !== 'all') {
                currentUrl.searchParams.set(key, value);
            }
        });

        window.history.replaceState(null, '', currentUrl.toString());
    }

    handleButtonVisibility() {
        if (
            parseInt(this.maxPages) === 1 ||
            parseInt(this.currentPage) === parseInt(this.maxPages)
        ) {
            this.loadMoreButtonWrapper.classList.add('d-none');
        } else {
            this.loadMoreButtonWrapper.classList.remove('d-none');
        }
    }

    showFilters() {
        this.form.classList.add('-active');
    }

    hideFilters() {
        this.form.classList.remove('-active');
    }
}

const sections = document.querySelectorAll('section.listing');

if (sections.length > 0) {
    sections.forEach(section => {
        const productsListing = new ProductsListing(section);
    });
}
